<oui-slide-toggle label="Mise en place de versements programmés" [control]="vpsControl"></oui-slide-toggle>
